/* src/components/AllDone.svelte generated by Svelte v3.32.3 */
import {
	SvelteComponent,
	append,
	attr,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	mount_component,
	noop,
	safe_not_equal,
	space,
	text,
	transition_in,
	transition_out
} from "../_snowpack/pkg/svelte/internal.js";

import CheckCircle from "./Icon/CheckCircle.svelte.js";
import Localized from "./Lang/Localized.svelte.js";

function create_fragment(ctx) {
	let div2;
	let div0;
	let checkcircle;
	let t0;
	let div1;
	let h1;
	let t1;
	let t2;
	let h3;
	let localized;
	let current;
	checkcircle = new CheckCircle({});
	localized = new Localized({ props: { key: "ALL_COMPLETE" } });

	return {
		c() {
			div2 = element("div");
			div0 = element("div");
			create_component(checkcircle.$$.fragment);
			t0 = space();
			div1 = element("div");
			h1 = element("h1");
			t1 = text("100%");
			t2 = space();
			h3 = element("h3");
			create_component(localized.$$.fragment);
			this.h();
		},
		l(nodes) {
			div2 = claim_element(nodes, "DIV", { class: true });
			var div2_nodes = children(div2);
			div0 = claim_element(div2_nodes, "DIV", { class: true });
			var div0_nodes = children(div0);
			claim_component(checkcircle.$$.fragment, div0_nodes);
			div0_nodes.forEach(detach);
			t0 = claim_space(div2_nodes);
			div1 = claim_element(div2_nodes, "DIV", { class: true });
			var div1_nodes = children(div1);
			h1 = claim_element(div1_nodes, "H1", { class: true });
			var h1_nodes = children(h1);
			t1 = claim_text(h1_nodes, "100%");
			h1_nodes.forEach(detach);
			t2 = claim_space(div1_nodes);
			h3 = claim_element(div1_nodes, "H3", { class: true });
			var h3_nodes = children(h3);
			claim_component(localized.$$.fragment, h3_nodes);
			h3_nodes.forEach(detach);
			div1_nodes.forEach(detach);
			div2_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(div0, "class", "h-12 w-12 flex-none text-green-500 dark:text-green-200");
			attr(h1, "class", "font-medium text-gray-700 dark:text-gray-100");
			attr(h3, "class", "text-xs text-gray-500 dark:text-gray-300");
			attr(div1, "class", "px-3");
			attr(div2, "class", "shadow pt-2 pb-1 px-3 rounded-t-none rounded-b-md flex flex-row border-t-2 bg-white border-green-500 dark:bg-gray-700 dark:border-green-200");
		},
		m(target, anchor) {
			insert(target, div2, anchor);
			append(div2, div0);
			mount_component(checkcircle, div0, null);
			append(div2, t0);
			append(div2, div1);
			append(div1, h1);
			append(h1, t1);
			append(div1, t2);
			append(div1, h3);
			mount_component(localized, h3, null);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(checkcircle.$$.fragment, local);
			transition_in(localized.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(checkcircle.$$.fragment, local);
			transition_out(localized.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div2);
			destroy_component(checkcircle);
			destroy_component(localized);
		}
	};
}

class AllDone extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, null, create_fragment, safe_not_equal, {});
	}
}

export default AllDone;
//# sourceMappingURL=AllDone.svelte.js.map
